export const fetchStatus = {
  FETCH_START: 'FETCH_START',
  FETCH_FAIL: 'FETCH_FAIL',
  FETCH_SUCCESS: 'FETCH_SUCCESS',
};

export const postStatus = {
  POST_START: 'POST_START',
  POST_FAIL: 'POST_FAIL',
  POST_SUCCESS: 'POST_SUCCESS',
};
